@import '../../../global/style.scss';

@font-face {
  font-family: 'ArialRoundedMTforSE_Latin';
  font-weight: 400;
  font-style: normal;
  src: url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Regular.eot');
  src: local('Arial Rounded Regular'), local('Arial-Rounded-Regular'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Regular.eot?#iefix')
      format('embedded-opentype'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Regular.woff2')
      format('woff2'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Regular.woff')
      format('woff'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Regular.ttf')
      format('truetype'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Regular.svg#Arial_W10_Rounded_Regular')
      format('svg');
}

@font-face {
  font-family: 'ArialRoundedMTforSE_Latin';
  font-weight: 300;
  font-style: normal;
  src: url('#{$se-fonts-path}/arial_rounded/Arial_Rounded_MT_W04_Light.eot');
  src: local('Arial Rounded Light'), local('Arial-Rounded-Light'),
    url('#{$se-fonts-path}/arial_rounded/Arial_Rounded_MT_W04_Light.eot?#iefix')
      format('embedded-opentype'),
    url('#{$se-fonts-path}/arial_rounded/Arial_Rounded_MT_W04_Light.woff2')
      format('woff2'),
    url('#{$se-fonts-path}/arial_rounded/Arial_Rounded_MT_W04_Light.woff')
      format('woff'),
    url('#{$se-fonts-path}/arial_rounded/Arial_Rounded_MT_W04_Light.ttf')
      format('truetype'),
    url('#{$se-fonts-path}/arial_rounded/Arial_Rounded_MT_W04_Light.svg#Arial_Rounded_MT_W04_Light')
      format('svg');
}

@font-face {
  font-family: 'ArialRoundedMTforSE_Latin';
  font-weight: bold;
  font-style: normal;
  src: url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Bold.eot');
  src: local('Arial Rounded Bold'), local('Arial-Rounded-Bold'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Bold.eot?#iefix')
      format('embedded-opentype'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Bold.woff2')
      format('woff2'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Bold.woff')
      format('woff'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Bold.ttf')
      format('truetype'),
    url('#{$se-fonts-path}/arial_rounded/Arial_W10_Rounded_Bold.svg#Arial_W10_Rounded_Bold')
      format('svg');
}

rt-style-wrapper {
  display: block;
  font-family: 'ArialRoundedMTforSE_Latin', Arial, 'Helvetica Neue', sans-serif;
}
